import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button } from 'govuk-react-jsx';
import { useSelector } from 'react-redux';
import {
  getCurrentLanguage,
  getCopyProviderCY,
  getCopyProviderEN,
} from '../../features/app/appSlice';
import {
  getCompanyData,
  getBusinessVatData,
} from '../../features/registration/registrationJourneySlice';
import { getUserDetails } from '../../features/dashboard/dashboardSlice';
import useTitle from '../../hooks/useTitle';

const Declaration = () => {
  const currentLanguage = useSelector(getCurrentLanguage);
  const copyProviderCY = useSelector(getCopyProviderCY);
  const copyProviderEN = useSelector(getCopyProviderEN);
  const copyProvider =
    currentLanguage === 'en' ? copyProviderEN : copyProviderCY;
  const companyDataRedux = useSelector(getCompanyData);
  const businessVatDataRedux = useSelector(getBusinessVatData);
  const currentUserData = useSelector(getUserDetails);
  const history = useHistory();
  useTitle(
    'landlordApp.Declaration.s13',
    'Declaration - OZEV Electric Vehicle Chargepoint Grant - GOV.UK'
  );
  const handleBtnClick = () => {
    history.push('/landlordApp/installer-details');
  };

  return (
    <>
      <span className="govuk-caption-xl">
        {companyDataRedux && companyDataRedux.company_name}
        {businessVatDataRedux && businessVatDataRedux.target.name}
        {currentUserData != null &&
          currentUserData.business_name != null &&
          currentUserData.business_name}
      </span>
      <h1 className="govuk-heading-xl">
        {copyProvider.getCopy('landlordApp.Declaration.s1', 'Declaration')}
      </h1>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordApp.Declaration.s2',
          'By continuing, you confirm that you:'
        )}
      </p>
      <ul className="govuk-list govuk-list--bullet">
        <li>
          {copyProvider.getCopy(
            'landlordApp.Declaration.s3',
            'have agreed to complete the installation with an Office for Zero Emission Vehicles (OZEV) authorised installer'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'landlordApp.Declaration.s4',
            'will provide the correct information to the best of your knowledge'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'landlordApp.Declaration.s5',
            'understand that the information and supporting evidence you provide will be used to assess your application and claim for this grant'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'landlordApp.Declaration.s6',
            'agree to work with OZEV or its agents should the installation be chosen for audit'
          )}
        </li>
        <li>
          {copyProvider.getCopy(
            'landlordApp.Declaration.s7',
            "understand that any chargepoints you apply for must be installed in the property's private parking"
          )}
        </li>
      </ul>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordApp.Declaration.s10',
          'You also confirm that when installing a chargepoint, you will consider accessibility and mobility needs of EV owners.'
        )}
      </p>
      <p className="govuk-body">
        {copyProvider.getCopy(
          'landlordApp.Declaration.s8',
          'Your information will be handled in accordance with the '
        )}
        <a
          href="https://www.gov.uk/government/organisations/office-for-low-emission-vehicles/about/personal-information-charter"
          target="_blank"
          className="govuk-link"
          rel="noreferrer"
        >
          {copyProvider.getCopy(
            'landlordApp.Declaration.s9',
            'OZEV personal information charter (opens in new tab)'
          )}
        </a>
      </p>
      <div className="govuk-warning-text govuk-!-margin-top-7">
        <span className="govuk-warning-text__icon" aria-hidden="true">
          !
        </span>
        <strong className="govuk-warning-text__text">
          <span className="govuk-warning-text__assistive">Warning</span>
          <b>
            {copyProvider.getCopy(
              'landlordApp.Declaration.s11',
              'It is an offence to make a false declaration to obtain a grant and you could be fined or prosecuted.'
            )}
          </b>
        </strong>
      </div>
      <Button
        className="govuk-button-group govuk-!-margin-top-7"
        onClick={handleBtnClick}
      >
        {copyProvider.getCopy(
          'landlordApp.Declaration.s12',
          'Accept and continue'
        )}
      </Button>
    </>
  );
};

export default Declaration;
